
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configurator/widget-content/apps",
      function () {
        return require("private-next-pages/configurator/widget-content/apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configurator/widget-content/apps"])
      });
    }
  